export default {
  blueDemo: "#243d7f",
  button1: "rgba(36, 61, 127, 0.04)",
  redCheckboxBackground: "rgba(255, 26, 26, 0.3)",
  blue1: "#243D7F",
  white1: "#ffffff",
  gray1: "#FAFAFA",
  gray2: "#ECECEC",
  gray3: "#A7A8AB",
  gray4: "#8B8C90",
  gray5: "#696A6C",
  gray6: "#3E3D3F",
  grayScroll: "#E6E6E6",
  orange1: "#E26E26",
  red1: "#FF4444",
  red2: "#DD2227",
};
